module.exports = __webpack_public_path__ + "img/ereszkalkulator_26_minoseg_premium_szurke.894bef27.png";